import React, { useState } from "react";
import { TextField, Button, Paper, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

interface AdminLoginProps {
  onLoginSuccess: () => void;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setLoading(true);

  try {
    const formData = new FormData();
    formData.append("email", email.trim().toLowerCase());
    formData.append("password", password);

    const res = await axios.post("auth/auth_medicube_admin", formData, {
      headers: { accept: "application/json" },
    });

    const token = res.data; 
    if (!token) throw new Error("No token received");

    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    Cookies.set("token", token);
    console.log("Admin token set in cookies:", token);
    
    toast.success("Admin login successful!");
    navigate("/homepage_admin");

  } catch (err: any) {
    toast.error(err.response?.data?.detail || "Login failed");
  } finally {
    setLoading(false);
  }
};


  return (
    <Paper
      elevation={3}
      style={{
        maxWidth: 400,
        margin: "80px auto",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <Typography variant="h5" gutterBottom>
        Admin Login
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          margin="normal"
        />
        <TextField
          label="Password"
          type="password"
          variant="outlined"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          margin="normal"
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          type="submit"
          disabled={loading}
          style={{ marginTop: 16 }}
        >
          {loading ? "Logging in..." : "Login"}
        </Button>
      </form>
    </Paper>
  );
};

export default AdminLogin;
